<template>
    <div class="linked-content-dialog-body">
        <div class="menu" v-if="items">
            <a :class="`item ${item.tagName}`" @click="goto(item)" v-for="item in items" :key="item._ui">
                <typo name="link">{{ item.innerText }}</typo>
            </a>
        </div>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
        <convention-body v-html="body" mode="linked-content"></convention-body>
    </div>
</template>

<script>

    import Vue from 'vue'
    import ConventionBody from 'src/components/convention/ConventionBody.vue'
    export default Vue.extend({
        props: ["body", "mode"],
        components: { ConventionBody },
        data() {
            return {
                items: null
            }
        },
        mounted() {
            this.updateMenu();
        },
        watch: {
            body() {
                this.updateMenu();
            }
        },
        methods: {
            updateMenu() {
                this.$el.parentNode.scrollTo(0, 0);
                this.items = this.$el.querySelectorAll("h1,h2");
            },
            goto(item) {
                if ( this.mode == "page" ) {
                    this.$vuetify.goTo(item.offsetTop + 80);
                } else {
                    this.$el.parentNode.scrollTo(0, item.offsetTop - 80);
                }
            }
        }
    });
</script>

<style lang="sass" scoped>
.item
    display: block
    &.H2
        margin-left: 10px

.menu
    margin-bottom: 30px

@media print
    .item.H2
        margin-left: 0
        color: #4a7ab8 !important 
        font-weight: 500
</style>